<template>
  <router-view/>
</template>

<script>
  import ChangeTitleMixin from "../../../mixins/ChangeTitleMixin";

  export default {
    name: "Payments",
    mixins: [ChangeTitleMixin('Pagos')],
  }
</script>
